import React from 'react';
import type { RouteObject } from 'react-router-dom';
import RequireRole from '../../shared/guards/RequireRole';
import CafeMenuDashboard from './CafeMenuDashboard';

const g = (el: React.ReactElement) => <RequireRole allowedRoles={['Owner']}>{el}</RequireRole>;

export const cafeMenuRoutes: RouteObject[] = [
  { path: 'cafe-menu', element: g(<CafeMenuDashboard />) },
];
